import React from "react";

import Hidden from "@material-ui/core/Hidden";

import BasicDesktop from "./BasicDesktop";
import BasicMobile from "./BasicMobile";

function BasicScreen() {
  return (
    <>
      <Hidden only={["md", "lg", "xl"]}>
        <BasicMobile />
      </Hidden>
      <Hidden only={["xs", "sm"]}>
        <BasicDesktop />
      </Hidden>
    </>
  );
}

export default React.memo(BasicScreen);
